export default __webpack_public_path__ + "static/assets/45154dd48b4f4d62501a9c97781ee588.svg";